import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { KeyFigure, KeyFigureService } from '../services/key-figure.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { PostService } from '../services/post.service';
import { SlicePostsPipe } from '../slice-posts.pipe';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, TranslateModule, CommonModule, SlicePostsPipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  baseApiUrl: string = environment.baseApiUrl;

  keyFigure: KeyFigure | null = null;
  posts: any[] = [];

  homepageSliders: any[] = [];

  constructor(private keyFigureService: KeyFigureService, private postService: PostService, private translate: TranslateService, private http: HttpClient) {}

  ngOnInit(): void {
    this.getLatestKeyFigure();

    this.getPosts(1, 10);

    this.loadHomepageSlider();
  }

  loadHomepageSlider(): void {
    this.http.get<any>(`${this.baseApiUrl}/galleries/homepage-sliders`).subscribe({
      next: (res) =>  {
        if (res?.data?.files) {
          this.homepageSliders = res.data.files;
        }
      },
      error: (err) => {
        console.log('Error loading homepage slider:', err);
      }
    })
  }

  isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }


  getPosts(page: number, limit: number) {
    this.postService.getPosts(page, limit).subscribe(res => {
      this.posts = res.data.posts;
    })
  }

  getLatestKeyFigure(): void {
    this.keyFigureService.getLatestKeyFigure().subscribe(response => {
      this.keyFigure = response;
    });
  }


  ceoMessageEn = {
    title: 'Turning Challenges into Resilience and Adaptability',
    text_1: 'Border tensions, subdued credit demand, a sluggish recovery in tourism and real estate — 2025 compounded an already demanding environment. Across the banking system, Non-Performing Loans climbed to 8.9 percent from 7.4 percent in 2024, while outstanding loans grew modestly at 4.1 percent to USD 63 billion. Deposits surged 14.7 percent to USD 65.7 billion and total assets expanded 9.7 percent to USD 98.7 billion — a system with liquidity, but exercising discipline about where to deploy it. The era of expansion-driven banking gave way to something more demanding: risk-focused, resilience-oriented practice.',
    //text_2: 'Considering heightened credit markets, NHFC remains cautious and strategic in lending, reforming credit operating structure, bolstering internal control system, offering targeted pricing, developing talents; thereby enhancing risk management, sharpening competitiveness, satisfying client’s evolving behavior, and accelerating staff’s capability and professionalism training and development.'
  }


  ceoMessageKh = {
    title: 'បំលែងវិបត្តិ និងកត្តាប្រឈមឲ្យក្លាយជាភាពរឹងមាំ និងសមត្ថភាពបន្សាំខ្លួន',
    text_1: 'ភាពតានតឹងតាមព្រំដែនតម្រូវការឥណទាននៅមានកម្រិតទាប និងភាពយឺតយ៉ាវនៃការស្តារឡើងវិញក្នុងវិស័យទេសចរណ៍ និងអចលនទ្រព្យបានបន្តដាក់សម្ពាធដល់សកម្មភាពអាជីវកម្មក្នុងឆ្នាំ ២០២៥។ អត្រាឥណទានមិនដំណើរការ (NPL) ប្រព័ន្ធធនាគារទាំងមូលបានហក់ឡើងដល់ ៨.៩% ពី ៧.៤% ក្នុងឆ្នាំ ២០២៤ ខណៈឥណទានសរុបកើនឡើងត្រឹម ៤.១% ស្មើនឹង ៦៣ ពាន់លានដុល្លារអាមេរិក នេះបើយោងតាមរបាយការណ៍។ ទន្ទឹមនឹងនេះ ប្រាក់បញ្ញើបានកើនឡើង ១៤.៧% ដល់ ៦៥.៧ ពាន់លានដុល្លារអាមេរិក និងទ្រព្យសកម្មសរុបកើនឡើង ៩.៧% ដល់ ៩៨.៧ ពាន់លានដុល្លារអាមេរិក។ នេះបង្ហាញថាប្រព័ន្ធធនាគារនៅមានសាច់ប្រាក់គ្រប់គ្រាន់ប៉ុន្តែបន្តប្រតិបត្តិការប្រកបដោយភាពប្រុងប្រយ័ត្នកាន់តែខ្លាំងក្នុងការបញ្ចេញឥណទាន។ នេះជារបត់ថ្មីមួយនៃការវិវឌ្ឍន៍វិស័យធនាគារពីការរីកចម្រើនផ្អែកលើការពង្រីកផលបត្រឥណទានខ្លាំងឆ្ពោះទៅកាន់ដំណាក់កាលផ្តោតខ្លាំងលើការគ្រប់គ្រងហានិភ័យ និងភាពធន់។'
  }
  

}
